/**
 * Options for the grid-backed queries that read records the user creates and edits
 * elsewhere in the application - interests, business cases, service cases, invoices.
 *
 * None of the grid endpoints is invalidated by those mutations, so a staleness
 * window would let the panel show pre-change data right after the user acted on a
 * record. These queries therefore always refetch on reopen.
 *
 * Slow-changing data uses CUSTOMER_INSIGHTS_REFRESH_ON_REOPEN_OPTIONS instead.
 */
export const CUSTOMER_INSIGHTS_REFRESH_VOLATILE_OPTIONS = {
  refetchOnMountOrArgChange: true,
} as const;
